import Footer from 'components/common/Footer'
import Logo from 'components/common/Logo'
import { Outlet } from 'react-router'

function AuthLayout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <main className="d-flex flex-column flex-grow-1">
        <section className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
          <Logo alt="logo" className="mb-4" height={50} />
          <h3 className="text-center mb-4 text-lighter fw-semibold mt-3">Welcome to Finops Center</h3>

          <div className="w-100" style={{ maxWidth: '450px' }}>
            <Outlet />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}
export default AuthLayout
